import request from '@/utils/request'

// 查询列表
export function apiTeamScheduleList(query) {
  return request({
    url: '/bom/team/schedule/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiTeamScheduleUpdate (data) {
  return request({
    url: '/bom/team/schedule/save',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiTeamScheduleExport (data) {
  return request({
    url: '/bom/team/schedule/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiTeamScheduleDel (id) {
  return request({
    url: '/bom/team/schedule/remove',
    method: 'post',
    data: id
  })
}

/**
 * 获取日志代码
 * @description id 是业务编码， type是类型  ，不同的日志不同
班组日志：   id 是 班组编码 type 是 2
班组人员日志：   id 是 行ID type 是 3
班组排班日志：   id 是 行ID type 是 4
 * @param {Object} params
 * @returns
 */
export function apiGetLog(params) {
  return request({
    url: '/mes/mesWipLog/selectMesWipCommonLogs',
    method: 'get',
    params: params
  })
}
